export const fnSegmentSettings = ({ isCoworkingEnabled }, coworkingOfferType) => ({
  isCoworkingEnabled: isCoworkingEnabled && !!coworkingOfferType,
  coworkingOfferType,
});

export const getSegmentSettings = (config, { userCanPublishCoworking }) => {
  return {
    isCoworkingEnabled: userCanPublishCoworking,
  };
};
